// sum of potentially undefined variables are annoying to deal with.
export const sum = (
  numbers: (number | undefined | null)[] | Record<string, unknown>
): number => {
  const parsedNumbers =
    typeof numbers === 'object' ? Object.values(numbers) : numbers;
  // use .flatMap() instead of filter because .filter() require manual type casting
  // or it and will return unknown[] instead of number[].
  const trimmedNumbers = parsedNumbers.flatMap(n =>
    typeof n === 'number' ? n : []
  );
  return trimmedNumbers.reduce((a, b) => a + b, 0);
};
